export default "__VITE_ASSET__CRCKN$fJ__"